<template>
  <b-form-group
    label="Sıra No"
    :label-for="iKey + '_ordering'"
  >
    <b-input-group>
      <b-form-input
        :id="iKey + '_ordering'"
        v-model="dataItem[iKey].ordering"
        placeholder="Sıra No"
      />
      <b-input-group-append>
        <b-button
          variant="success"
          class="btn-icon"
          :disabled="!dataItem[iKey].id"
          @click="saveData(iKey)"
        >
          <FeatherIcon icon="SaveIcon" />
        </b-button>
      </b-input-group-append>
    </b-input-group>
  </b-form-group>
</template>

<script>
import {
  BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BButton,
} from 'bootstrap-vue'

export default {
  name: 'OrderNumber',
  components: {
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BButton,
  },
  props: {
    iKey: {
      type: Number,
      required: true,
    },
    saveData: {
      type: Function,
      required: true,
    },
  },
  computed: {
    dataItem() {
      return this.$store.getters['productItems/dataList']
    },
  },
}
</script>
